import { useCallback, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import Modal from "../../../../../components/Modal";
import { Title, Text, SmallText, SuccessIcon, Continue, Cancel, Submit, Actions, Flex } from "./styles";
import { SessionInDto } from "../../../../../types";
import {
  deleteSession,
  resetDeleteOneSession,
} from "../../../../../store/actions/session";
import { hideModal } from "../../../../../store/actions/modal";
import { Icon } from "../../../../../components/Icon/styles";
import checkIcon from "../../../../../assets/icons/check-bold.svg";


import { Formik } from "formik";
import Checkbox from "../../../../../components/FormikForm/Checkbox";


import trashIcon from "../../../../../assets/icons/trash.svg";
import { useHistory } from "react-router";
import * as Yup from "yup";
import { useTheme } from "styled-components";
import RichTextEditor from "../../../../../components/FormikForm/RichTextEditor";
import { isFutureDate } from "../../../../../helpers/dates-hanlder";
import { validateCharacterLimitWithContext } from "../../../../../helpers/formBodyCharacterLimitValidation";

export const schema = Yup.object().shape({
  notify_action: Yup.array().of(Yup.string()).nullable(),
  action_notification_message: Yup.string().nullable()
    .test(
      'character-limit',
      'No puedes usar más de caracteres', // El mensaje se maneja dinámicamente en la función
      function (value) {
        return validateCharacterLimitWithContext.call(this, value, 500); // 1000 caracteres máximo
      }
    ),
});

interface FormValues {
  notify_action: string[];
  action_notification_message: string
}

export const initialValues: FormValues = {
  notify_action: ["false"],
  action_notification_message: ""
};

interface ComponentProps {
  session: SessionInDto;
  deleteSessionState: {
    loading: boolean;
    success: boolean;
    error: string | boolean;
  };
}

const Component = ({ session, deleteSessionState }: ComponentProps) => {
  const theme = useTheme() as { colors: { [key: string]: string } }
  const history = useHistory();
  const dispatch = useDispatch();
  const [countdown, setCountdown] = useState(5);
  const [articleDeleted, setArticleDeleted] = useState(false)
  const [formSubmmited, setFormSubmmited] = useState(false);

  const onSubmit = ({ values, actions }) => {
    dispatch(deleteSession({ idSession: session?.id, ...values, notify_action: values.notify_action.includes("true") }));
  }

  const onModalClose = useCallback(() => {
    if (deleteSessionState.success) {
      dispatch(hideModal())
      dispatch(resetDeleteOneSession());
      window.location.href = `/dashboard/${session?.group?.group_type}/${session?.group?.id}/sessions/`;
    }
  }, [session, deleteSessionState.success]);

  useEffect(() => {
    if (deleteSessionState.success) {
      setArticleDeleted(true)
    }
  }, [deleteSessionState.success])

  useEffect(() => {
    if (articleDeleted) {
      if (countdown > 0) {
        const timer = setTimeout(() => {
          setCountdown(countdown - 1);
        }, 1000);

        return () => clearTimeout(timer);
      } else {
        dispatch(hideModal())
        dispatch(resetDeleteOneSession());
        window.location.href = `/dashboard/${session?.group?.group_type}/${session?.group?.id}/sessions/`;
      }
    }
  }, [articleDeleted, countdown]);

  return (
    <Modal
      name="modal-delete-session"
      width={deleteSessionState.success ? "320" : "500"}
      onClose={() => onModalClose()}
    >
      {deleteSessionState.success ? (
        <>
          <Flex>
            <SuccessIcon>
              <Icon icon={checkIcon} size="55px" color="#4CA154" />
            </SuccessIcon>
          </Flex>
          <div style={{ height: 28 }} />
          <Title>
            El encuentro se elimino correctamente
          </Title>
          <div style={{ height: 8 }} />
          <Text>
            Tené en cuenta que esta acción es definitiva y no podrás volver a acceder a él.
          </Text>
          <div style={{ height: 28 }} />
          <Actions style={{ justifyContent: 'center' }}>
            <Continue
              onClick={() => {
                dispatch(hideModal());
                dispatch(resetDeleteOneSession());
              }}
              href={`/dashboard/${session?.group?.group_type}/${session?.group?.id}/sessions/`}
              options={{
                type: 'filled',
                size: 'md',
                skin: 'purple'
              }}
            >
              Volver a Encuentros
            </Continue>
          </Actions>
          <div style={{ height: 8 }} />
          <SmallText>Toca "Volver a encuentros" o aguarda ({countdown} seg.)<br />y serás redirigido </SmallText>
        </>
      ) : (
        <>
          <Title>Vas a eliminar un encuentro</Title>
          <div style={{ height: 8 }} />
          <Text>
            Estás por eliminar el encuentro “{session?.title}”. Una vez eliminado
            no podrás recuperarlo y quienes tenían acceso al mismo ya no
            podrán verlo.
          </Text>
          <div style={{ height: 28 }} />
          <Formik
            initialValues={initialValues}
            onSubmit={(values, actions) => {
              if (onSubmit) onSubmit({ values, actions });
            }}
            validateOnChange={false}
            validateOnBlur={formSubmmited}
            validationSchema={schema}
            enableReinitialize
          >
            {({ handleSubmit, errors, touched, values, setFieldValue, setFieldError, setFieldTouched, handleChange, handleBlur, }) => {
              return (
                <form
                  className="theme-form"
                  onSubmit={(event) => {
                    setFormSubmmited(true);
                    handleSubmit(event);
                  }}
                  id="delete-session-form"
                >
                  {isFutureDate(session?.session_datetime) && (
                    <>
                      <Checkbox
                        name="notify_action"
                        error={errors["notify_action"]}
                        touched={touched["notify_action"]}
                        value={values["notify_action"]}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        items={[
                          { label: "Enviar una notificación a tus suscriptores.", value: "true" },
                        ]}
                        options={{
                          marginBottom: 0,
                        }}
                      />

                      <div style={{ height: 20 }} />

                      <span>Agrega un mensaje personalizado explicando el motivo de la cancelación (opcional)</span>

                      <div style={{ height: 12 }} />

                      <RichTextEditor
                        name={"action_notification_message"}
                        entityType="session_reminder"
                        error={errors[`action_notification_message`]}
                        touched={touched[`action_notification_message`]}
                        value={values[`action_notification_message`]}
                        placeholder="Ingresa tu mensaje aquí"
                        showToolbar={false}
                        max={500}
                        onBlur={handleBlur}
                        // onChange={({ isCountValid }) => {
                        //   if (!isCountValid) {
                        //     setFieldError(
                        //       "action_notification_message",
                        //       "Superaste la cantidad de caracteres máximos permitidos"
                        //     );
                        //   } else {
                        //     setFieldTouched("action_notification_message", false, false);
                        //   }
                        // }}
                        options={{
                          label: "",
                          height: 100,
                          marginBottom: 20,
                        }}
                      />
                    </>

                  )}

                </form>
              );
            }}
          </Formik>
          <div style={{ height: 28 }} />
          <Actions>
            <Cancel
              options={{
                type: "outline",
                skin: "purple",
                size: "lg",
              }}
              disabled={deleteSessionState.loading}
              onClick={() => dispatch(hideModal())}
            >
              Cancelar
            </Cancel>

            <Submit
              form="delete-session-form"
              isSubmmiting={deleteSessionState.loading}
              options={{
                type: "filled",
                skin: "purple",
                size: "lg",
              }}
              style={{ gap: 6 }}
            >
              <Icon icon={trashIcon} size="18px" color="#FFFFFF" />
              Eliminar encuentro
            </Submit>
          </Actions>
        </>
      )}
    </Modal>
  );
};

const state = ({ sessionStore }) => {
  const { data: session, states: sessionStates } = sessionStore.one;
  const { states: deleteSessionState } = sessionStore.deleteOne;

  return {
    session,
    sessionStates,
    deleteSessionState,
  };
};

export default connect(state)(Component);
